import React from "react";
import "./Contact.css";

export default function Contact() {
  // 👉 Số điện thoại nhận SMS
  const phone = "0763823860";

  // 👉 Nội dung tin nhắn mặc định
  const message =
    "Chào shop, mình muốn rút tiền thẻ tín dụng, báo phí ưu đãi hôm nay giúp mình qua zalo: ";

  // 👉 Encode tránh lỗi ký tự
  const encodedMessage = encodeURIComponent(message);

  // 👉 Link SMS mở app nhắn tin
  const smsLink = `sms:${phone}?body=${encodedMessage}`;

  return (
    <div className="ct-wrapper">
      {/* Nút NHẮN TIN */}
      <a
        onClick={() => {
          window.dataLayer = window.dataLayer || [];

          window.dataLayer.push({
            event: "click_zalo",
          });
        }}
        href={smsLink}
        className="ct-zalo-btn"
        aria-label="Nhắn tin"
      >
        Nhắn Tin
      </a>

      {/* Thanh GỌI ĐIỆN */}
      <a
        href="tel:0763823860"
        className="ct-call-bar"
        onClick={() => {
          window.dataLayer = window.dataLayer || [];

          window.dataLayer.push({
            event: "click_call",
          });
        }}
        aria-label="Gọi điện"
      >
        <img className="ct-call-icon" src="/call.svg" alt="Gọi" />
        <span className="ct-call-number">0763 823 860</span>
      </a>
    </div>
  );
}
